"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagerSmall = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var FlatButton_1 = __importDefault(require("@atg/icf-react-components/components/FlatButton"));
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var useStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    wrapper: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        gap: "".concat(theme.spacing.base, "px"),
        "& a": {
            // Override TypographyStyles, see https://jira.atg-corp.com/browse/DEV-105505
            color: "var(--color)",
        },
    },
}); });
var PagerSmall = function (props) {
    var _a = __read((0, Ioc_1.useContexts)(Contexts_1.ITranslationServiceContext, Contexts_1.ILinkComponentContext), 2), translationService = _a[0], Link = _a[1];
    var nextPageLinkTo = props.nextPageLinkTo, prevPageLinkTo = props.prevPageLinkTo, onNextClick = props.onNextClick, onPrevClick = props.onPrevClick;
    var styles = useStyles();
    var LinkLeftComponent = (react_1.default.createElement(FlatButton_1.default, { as: Link, iconLeft: "chevronLeft", label: translationService.translate("pager.previous"), to: prevPageLinkTo !== null && prevPageLinkTo !== void 0 ? prevPageLinkTo : "", onClick: onPrevClick, "data-ta-locator": "previous_action" }));
    var LinkRightComponent = (react_1.default.createElement(FlatButton_1.default, { as: Link, iconRight: "chevronRight", label: translationService.translate("pager.next"), to: nextPageLinkTo !== null && nextPageLinkTo !== void 0 ? nextPageLinkTo : "", onClick: onNextClick, "data-ta-locator": "previous_action" }));
    return (react_1.default.createElement("div", { className: styles.wrapper },
        react_1.default.createElement("div", null, prevPageLinkTo && LinkLeftComponent),
        react_1.default.createElement("div", null, nextPageLinkTo && LinkRightComponent)));
};
exports.PagerSmall = PagerSmall;
exports.PagerSmall.displayName = "PagerSmall";
//# sourceMappingURL=PagerSmall.js.map